<template>
   <div>
      <div>
         <v-form
            ref="create_locations"
            v-model="valid_create_locations"
         >
            <registration-title :title="$t('create_location_title')" hide_hr="true">
               {{$t('create_location_text')}}
            </registration-title>
            <div v-if="user" class="grid grid-cols-1 gap-1">
               <residenza-block
                  :title="$t('Città dove vivo')" :subtitle="indirizzo(user, 1)"
                  :info="info1"
                  :residence_number="1"
                  @deleteResidence="getDeleteN"
                  @emitPosition="getEmitPositionN"
                  :show_value="false"
               ></residenza-block>
               <v-text-field
                  class="input_transparent"
                  :rules="[validation_rules.required]"
                  v-model="info1.nazione"
               ></v-text-field>
               <hr class="my-2">
               <registration-title :title="$t('create_location_2_title')" hide_hr="true" class="mb-2">
                  {{$t('create_location_2_text')}}
               </registration-title>
               <residenza-block :title="$t('Prima città di appoggio')" :subtitle="indirizzo(user, 2)" :info="info2" :residence_number="2" @deleteResidence="getDeleteN" @emitPosition="getEmitPositionN" :show_value="false"></residenza-block>
               <hr class="my-2">
               <residenza-block :title="$t('Seconda città di appoggio')" :subtitle="indirizzo(user, 3)" :info="info3" :residence_number="3" @deleteResidence="getDeleteN" @emitPosition="getEmitPositionN" :show_value="false"></residenza-block>

            </div>
            <div class="flex justify-between items-end mt-5 pt-1 border-t border-[#e5e7eb]">
               <!-- <a color="#808080" @click="logout">Logout</a> -->
                  <v-btn color="grey" dark :loading="btn_loading" @click="$emit('nextStep',2)">{{$t('Indietro')}}</v-btn>
               <v-btn color="green" dark :loading="btn_loading" @click="nextStep()">{{$t('Avanti')}}</v-btn>
            </div>
         </v-form>
      </div>
   </div>
</template>

<script>
import ResidenzaBlock from "@/components/ResidenzaBlock.vue"

export default {
   components: {
      ResidenzaBlock,
   },
   data() {
      return {
         btn_loading: false,
         disable_rules: true,
         valid_create_locations: true,

         info1: {},
         info2: {},
         info3: {},
      };
   },
   computed: {
      user() {
         let _user = this.$store.getters['user/user']
         this.setInfoN(_user, "1")
         this.setInfoN(_user, "2")
         this.setInfoN(_user, "3")
         return _user
      },
      
   },
   methods: {
      async nextStep(){
         this.disable_rules =  false
         await this.delay(200)
         let valid = await this.$refs.create_locations.validate();
         if(valid){
            this.sendEdit()
         }
      },
      async sendEdit(){
         this.btn_loading = true
         let body = {
            registrazioneCompletata: this.user.registrazioneCompletata < 4 ? 4 : this.user.registrazioneCompletata
         }
         for(let i = 1; i<=3; i++){
            body['indirizzo' + i] = this.user['indirizzo' + i];
            body['cap' + i] = this.user['cap' + i];
            body['citta' + i] = this.user['citta' + i];
            body['provincia' + i] = this.user['provincia' + i];
            body['regione' + i] = this.user['regione' + i];
            body['nazione' + i] = this.user['nazione' + i];
            body['lat' + i] = this.user['lat' + i];
            body['lon' + i] = this.user['lon' + i];
         }

         let response = await this.$store.dispatch('user/editUser',body)
         if(response.response.error){
            this.btn_loading = false
            return
         }
         this.$emit("nextStep",4)
         this.btn_loading = false
      },


      setInfoN(info, n) {
         this['info' + n].indirizzo = info['indirizzo' + n]
         this['info' + n].cap = info['cap' + n]
         this['info' + n].citta = info['citta' + n]
         this['info' + n].provincia = info['provincia' + n]
         this['info' + n].regione = info['regione' + n]
         this['info' + n].nazione = info['nazione' + n]
         this['info' + n].lat = info['lat' + n]
         this['info' + n].lon = info['lon' + n]
      },
      getEmitPositionN(event){
         let info = event.info
         let n = event.n

         this.user['indirizzo' + n] = info.indirizzo
         this.user['cap' + n] = info.cap
         this.user['citta' + n] = info.citta
         this.user['provincia' + n] = info.provincia
         this.user['regione' + n] = info.regione
         this.user['nazione' + n] = info.nazione
         this.user['lat' + n] = info.lat
         this.user['lon' + n] = info.lon
         
      },
      getDeleteN(n){

         let num = n

         this.user['indirizzo' + num] = null
         this.user['cap' + num] = null
         this.user['citta' + num] = null
         this.user['provincia' + num] = null
         this.user['regione' + num] = null
         this.user['nazione' + num] = null
         this.user['lat' + num] = null
         this.user['lon' + num] = null
         this.setInfoN(this.user, num)
         this.residenze--
      },
   },
};
</script>

<style lang="scss" scoped>
/*  */
</style>
